import React, { useState } from 'react';
import { Menu, Search, ChevronDown, HelpCircle, Settings, LayoutGrid, LogOut } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const GmailHeader = ({ onSearch, searchQuery, connectedEmail, onDisconnect }) => {
  const { user } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <div className="gmail-header" data-testid="gmail-header">
      <div className="gmail-header-left">
        <button className="gmail-icon-btn">
          <Menu size={20} />
        </button>
        <div className="gmail-logo">
          <img 
            src="https://ssl.gstatic.com/ui/v1/icons/mail/rfr/logo_gmail_lockup_default_1x_r5.png" 
            alt="Gmail" 
            className="gmail-logo-img"
          />
        </div>
      </div>
      
      <div className="gmail-header-middle">
        <form onSubmit={handleSearchSubmit} className="gmail-search-form">
          <Search size={20} className="gmail-search-icon" />
          <input
            type="text"
            placeholder="Search mail"
            value={searchQuery}
            onChange={(e) => onSearch(e.target.value)}
            className="gmail-search-input"
            data-testid="gmail-search-input"
          />
          <button type="button" className="gmail-search-options">
            <ChevronDown size={20} />
          </button>
        </form>
      </div>
      
      <div className="gmail-header-right">
        {connectedEmail && (
          <div className="gmail-connected-email">
            <span>{connectedEmail}</span>
          </div>
        )}
        <button className="gmail-icon-btn">
          <HelpCircle size={20} />
        </button>
        <button className="gmail-icon-btn">
          <Settings size={20} />
        </button>
        <button className="gmail-icon-btn">
          <LayoutGrid size={20} />
        </button>
        <div className="gmail-avatar-wrapper">
          <div 
            className="gmail-avatar" 
            data-testid="gmail-user-avatar"
            onClick={() => setShowMenu(!showMenu)}
          >
            {user?.photoUrl ? (
              <img src={user.photoUrl} alt={user.name} className="gmail-avatar-img" />
            ) : (
              <span className="gmail-avatar-initials">
                {getInitials(user?.name || user?.email)}
              </span>
            )}
          </div>
          {showMenu && (
            <div className="gmail-avatar-menu">
              <div className="gmail-avatar-menu-header">
                <strong>{user?.name || 'User'}</strong>
                <span>{user?.email}</span>
              </div>
              <div className="gmail-avatar-menu-divider" />
              <div className="gmail-avatar-menu-connected">
                <span>Connected Gmail:</span>
                <strong>{connectedEmail}</strong>
              </div>
              <div className="gmail-avatar-menu-divider" />
              <button 
                className="gmail-avatar-menu-item gmail-disconnect-btn"
                onClick={() => {
                  setShowMenu(false);
                  onDisconnect();
                }}
              >
                <LogOut size={16} />
                Disconnect Gmail
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GmailHeader;
